'use client';

import { useBannersSocket } from '@/queries/banners/banners.sockets';
import { useBundlesSocket } from '@/queries/bundles/bundles.sockets';
import { useFairPlayGameReportSocket } from '@/queries/fair-play/fair-play.sockets';
import { useFastShopSocket } from '@/queries/fast-shop/fast-shop.sockets';
import { useGameRoundVerificationSocket } from '@/queries/games/game.sockets';
import { useKYCSocket } from '@/queries/kyc/kyc.sockets';
import { usePaymentTransactionSocket } from '@/queries/paymentTransaction/paymentTransaction.sockets';
import { usePaymentMethodVerificationRequiredSocket, useUserSocket } from '@/queries/user/user.sockets';
import { useWalletSocket } from '@/queries/wallet/wallet.sockets';
import { useWithdrawSocket } from '@/queries/withdraw/withdraw.sockets';

export function SocketListeners() {
  useUserSocket();
  usePaymentMethodVerificationRequiredSocket();
  useWalletSocket();
  useKYCSocket();
  useWithdrawSocket();
  usePaymentTransactionSocket();
  useGameRoundVerificationSocket();
  useFairPlayGameReportSocket();
  useBundlesSocket();
  useBannersSocket();
  useFastShopSocket();

  return null;
}
